import {useState, useEffect} from 'react'
import DateTimePicker from 'react-datetime-picker/dist/entry.nostyle';
import '../../datetime.css'

const SchedulePublish = ({language, contentTypeId, scheduleDate, setScheduleDate, showSchedulePublish, setShowSchedulePublish}) => {
    const [editScheduleDate, setEditScheduleDate] = useState(new Date())
    
    useEffect(() => {
        const init = async () => {
            if(scheduleDate){
                setEditScheduleDate(new Date(scheduleDate))
            }
        }
        init()

    },[scheduleDate])

    const schedulePublish = async e => {
        let hours = editScheduleDate.getHours()
        let minutes = editScheduleDate.getMinutes()
        let schDate = editScheduleDate.getFullYear() 
                    + "-" + (editScheduleDate.getMonth() + 1)
                    + "-" + editScheduleDate.getDate()
                    + "T" + (hours === 0 ? "00" : hours)
                    + ":" + (minutes === 0 ? "00" : minutes)
        var graphql = JSON.stringify({
            query: `mutation ($contentTypeId: Guid, $scheduleDate: DateTime){
                        schedulePublishContentType(contentTypeId:$contentTypeId, scheduleDate:$scheduleDate) {
                            id
                            scheduleDate
                        }
                    }`,
            variables: {
                "contentTypeId": contentTypeId
                ,"scheduleDate": schDate
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            var d = new Date(resultData.schedulePublishContentType.scheduleDate)
            setScheduleDate(d)
            setShowSchedulePublish(false)
            return 
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data
    }

    const handleClose = async e => {
        e.preventDefault();
        
        setShowSchedulePublish(showSchedulePublish ? false : true)
    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(scheduleDate === ""){
            error = true
        }
        if(!error){
            await schedulePublish()
        }
    }

    return (
        <div id="cc_editarticle" className={showSchedulePublish ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Planlæg offentliggørelse' : 'Schedule publish'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Dato' : 'Date'}</span>
                    </label>
                    
                    <DateTimePicker
                        onChange={setEditScheduleDate}
                        value={editScheduleDate}
                        locale={language.value === "DA" ? "da-DK" : "en-GB"}
                    />
                </div>
                
                <div className="align_right">
                    <button onClick={handleSave} className={`cc-btn blue-gradient`}>{language.value === 'DA' ? 'Planlæg' : 'Schedule'}</button>
                </div>
            </div>
        </div>
    )
}

export default SchedulePublish
